// Sdílený AudioContext – odemyká se tichým bufferem na prvním dotyku kdekoliv na stránce.
// iOS/Android vyžadují uživatelské gesto, ale nechceme žádný slyšitelný artefakt.

let ctx = null;
let unlocked = false;

function doUnlock() {
  if (unlocked) return;
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    // Tichý jednorázový buffer – "odemkne" kontext bez slyšitelného zvuku
    const buf = ctx.createBuffer(1, 1, 22050);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    src.start(0);
    ctx.resume().then(() => { unlocked = true; });
  } catch {}
}

// Automaticky odemkni na prvním dotyku / kliknutí kdekoliv
if (typeof window !== 'undefined') {
  ['touchstart', 'touchend', 'mousedown'].forEach(ev =>
    document.addEventListener(ev, doUnlock, { once: false, passive: true })
  );
}

export function playSound(type) {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    const notes = type === 'IN' ? [880, 1100] : [440];
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0.3, ctx.currentTime + i * 0.15);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.15 + 0.3);
      osc.start(ctx.currentTime + i * 0.15);
      osc.stop(ctx.currentTime + i * 0.15 + 0.3);
    });
  } catch {}
}
